export const NEW_DRIVER = 'NEW_DRIVER';
export const NEW_DRIVER_SUCCESS = 'NEW_DRIVER_SUCCESS';
export const NEW_DRIVER_FAIL = 'NEW_DRIVER_FAIL';
export const NEW_VEHICLE = 'NEW_VEHICLE';
export const NEW_VEHICLE_SUCCESS = 'NEW_VEHICLE_SUCCESS';
export const NEW_VEHICLE_FAIL = 'NEW_VEHICLE_FAIL';
export const GET_CONFIG = 'GET_CONFIG';
export const GET_CONFIG_SUCCESS = 'GET_CONFIG_SUCCESS';
export const GET_DRIVERS = 'GET_DRIVERS';
export const GET_DRIVER_DETAILS = 'GET_DRIVER_DETAILS';
export const GET_DRIVERS_SUCCESS = 'GET_DRIVERS_SUCCESS';
export const GET_DRIVER_DETAILS_SUCCESS = 'GET_DRIVER_DETAILS_SUCCESS';
export const SET_NEW_DRIVER_FIELD = 'SET_NEW_DRIVER_FIELD';
export const SET_NEW_DRIVER_ERR = 'SET_NEW_DRIVER_ERR';
export const SET_DRIVER_ID = 'SET_DRIVER_ID';
export const ADD_DRIVER_DOCUMENT = 'ADD_DRIVER_DOCUMENT';
export const REMOVE_DRIVER_DOCUMENT = 'REMOVE_DRIVER_DOCUMENT';
export const NEXT_PAGE = "NEXT_PAGE"
export const PREV_PAGE = "PREV_PAGE"
export const CLEAR_DRIVER_STATE = "CLEAR_DRIVER_STATE"
export const CHANGE_DRIVER_STATUS = "CHANGE_DRIVER_STATUS"
export const CHANGE_DRIVER_STATUS_SUCCESS = "CHANGE_DRIVER_STATUS_SUCCESS"


